import {
  StaffAttendance,
  StaffAttendanceRowData
} from '../types/StaffAttendanceTypes';
import moment from 'moment';
import { StaffRoles } from '../../Staff/config/constant';
import { defaultMappedRole } from '../../../config/schoolConfig';

const roleLabelMap: Record<string, string> = StaffRoles.reduce(
  (labelByValue: Record<string, string>, current) => {
    labelByValue[current.value] = current.label;
    return labelByValue;
  },
  {}
);

const transformStaffAttendanceReportData = (
  data: StaffAttendance[],
  isDownloading: boolean = false
): Array<StaffAttendanceRowData | Record<string, any>> => {
  if (!Array.isArray(data)) return [];

  return data.map((record: StaffAttendance, index: number) => {
    const staffUser = record.users;
    const userRole =
      staffUser?.displayRole ||
      defaultMappedRole[staffUser?.role as unknown as string] ||
      staffUser?.role ||
      '';

    const markedBySourceMap: Record<string, string> = {
      CRON: 'SYSTEM',
      SYSTEM: 'SYSTEM',
      SELF: 'STAFF',
      STAFF: 'STAFF',
      ADMIN: 'ADMIN',
      TRACKER: 'DEVICE',
      DEVICE: 'DEVICE'
    };

    const data = {
      attendanceDate: record?.attendanceDate || '',
      memberCode: staffUser?.memberCode || '',
      staffName: staffUser?.name || '',
      role: userRole,
      status: record?.markedAs || '',
      markedBy: markedBySourceMap[String(record?.source)] || '',
      remark: record?.remarks || '',
      Shift: record?.shiftDetails?.startTime && record?.shiftDetails?.endTime
        ? `${record?.shiftDetails?.startTime} - ${record?.shiftDetails?.endTime}`
        : '',
      punchInTime: record?.punchInTime || '',
      punchOutTime: record?.punchOutTime || '',
      markedAsLate: record?.markedAsLate
    };

    if (!isDownloading) {
      return {
        ...data,
        id: `${index + 1}`,
        date: data.attendanceDate
          ? moment(data.attendanceDate).format('DD MMM, YYYY')
          : ''
      };
    }

    const DATE_FORMAT = 'DD-MMM-YYYY';
    return {
      Date: data.attendanceDate
        ? moment(data.attendanceDate).format(DATE_FORMAT)
        : '',
      'Member Code': data.memberCode,
      'Staff Name': data.staffName,
      Role: data.role,
      Status: data.status,
      'Marked By': data.markedBy,
      Shift: data.Shift,
      'Punch In Time': data.punchInTime,
      'Punch Out Time': data.punchOutTime,
      'Marked As Late':
        data.markedAsLate === true
          ? 'YES'
          : data.markedAsLate === false
            ? 'NO'
            : '',
      Remarks: data.remark
    };
  });
};

export { transformStaffAttendanceReportData, roleLabelMap };
